import axios from "axios";
import { authHeader } from "@/helpers/API/Auth/auth.header.js";

const API_URL = process.env.VUE_APP_ROOT_API;

class UserService {
  // Edit profile data
  async updateProfile(data) {
    return await axios
      .patch(API_URL + "user/detail", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // Get Staff List
  async getCRMStaffList(filter = "") {
    return await axios
      .get(API_URL + "user/crm/staff" + filter, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // Add Staff
  async addCRMStaffList(data) {
    return await axios
      .post(API_URL + "user/crm/staff", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // Edit Staff account
  async editCRMStaffList(id, data) {
    return await axios
      .patch(API_URL + "user/crm/staff/" + id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Delete Staff account
  async deleteCRMStaff(id) {
    return await axios
      .delete(API_URL + "user/crm/staff/" + id, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // Get all CRM users
  async getAllCRMUsers(filter = "") {
    return await axios
      .get(API_URL + "user/crm/company-all-user" + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
}

export default new UserService();
